import { List } from "antd/es";
import { useState, useMemo, useEffect } from "react";
import { countImagesPerModel } from "../../api";
import store from "../../store";
import { paginationConfig } from "./ModelStorageBrowser";
import { ModelListItem } from "./ModelListItem";

export const ModelList = ({ remoteModels, filters, onClick, currentModel, setCurrentModel }) => {
    const modelLookup = store.models.useModelLookup();
    const [imageCounts, setImageCounts] = useState({});

    const activeLoras = store.models.useActiveLoras();
    const setActiveLoras = store.models.useSetActiveLoras();

    const { localOnly, selecting, query } = filters;

    const filtered = useMemo(() => {
        const filtered = [...remoteModels]
            .filter(m => query ? m.path.includes(query) : true)
            .map(m => ({
                ...m,
                local: modelLookup[m.path],
            }));

        return localOnly ? filtered.filter(m => m.local) : filtered;
    }, [localOnly, modelLookup, query, remoteModels]);


    useEffect(() => {
        const updateCounts = () => {
            countImagesPerModel().then(setImageCounts);
        };

        updateCounts();

        const key = setInterval(() => updateCounts(), 30000);
        return () => clearInterval(key);
    }, []);

    return (
        <List
            pagination={paginationConfig}
            size={"small"}
            rowKey="path"
            loading={remoteModels.length === 0}
            dataSource={filtered}
            renderItem={(data, idx) => <ModelListItem
                data={data}
                imageCounts={imageCounts}
                key={idx}
                idx={idx}
                {...{ onClick, currentModel, setCurrentModel, selecting, activeLoras, setActiveLoras }} />}
            className="model-list" />
    );
};
